import http from './api'
import type {
  IngredientCatalogItem,
  IngredientRelatedItem,
  MyIngredientItem,
  CreateCustomIngredientData,
  UpdateCustomIngredientData,
} from '../types/ingredient'

class IngredientsService {
  async getCatalog(): Promise<IngredientCatalogItem[]> {
    const response = await http.get<IngredientCatalogItem[]>('/ingredients')
    return response.data
  }

  async getRelated(restaurantId: string): Promise<IngredientRelatedItem[]> {
    const response = await http.get<IngredientRelatedItem[]>(
      `/restaurants/${restaurantId}/ingredients/related`
    )
    return response.data
  }

  async getMyIngredients(restaurantId: string): Promise<MyIngredientItem[]> {
    const response = await http.get<MyIngredientItem[]>(
      `/restaurants/${restaurantId}/ingredients`
    )
    return response.data
  }

  async addCatalogToRestaurant(
    restaurantId: string,
    ingredientId: string
  ): Promise<void> {
    await http.post(`/restaurants/${restaurantId}/ingredients`, {
      ingredientId,
    })
  }

  async removeCatalogFromRestaurant(
    restaurantId: string,
    ingredientId: string
  ): Promise<void> {
    await http.delete(
      `/restaurants/${restaurantId}/ingredients/${ingredientId}`
    )
  }

  async createCustomIngredient(
    restaurantId: string,
    data: CreateCustomIngredientData
  ): Promise<MyIngredientItem> {
    const response = await http.post<MyIngredientItem>(
      `/restaurants/${restaurantId}/ingredients/custom`,
      data
    )
    return response.data
  }

  async updateCustomIngredient(
    restaurantId: string,
    customId: string,
    data: UpdateCustomIngredientData
  ): Promise<MyIngredientItem> {
    const response = await http.patch<MyIngredientItem>(
      `/restaurants/${restaurantId}/ingredients/custom/${customId}`,
      data
    )
    return response.data
  }

  async deleteCustomIngredient(
    restaurantId: string,
    customId: string
  ): Promise<void> {
    await http.delete(
      `/restaurants/${restaurantId}/ingredients/custom/${customId}`
    )
  }
}

const ingredientsService = new IngredientsService()
export default ingredientsService
